import(/* webpackMode: "eager" */ "/codebuild/output/src1065407848/src/patient-app/app/global-error.tsx");
